module.exports = __webpack_public_path__ + "img/icon_ghost.2229176e.svg";